import { ColumnFilter } from '@tanstack/react-table';
import { DateTime } from 'luxon';
import { useMemo } from 'react';

import { FilterType } from '@work4all/components';

import { RelativeDateFilter } from '@work4all/utils/lib/date-utils/RelativeDateFilter.enum';

export const useProjectHoursTableDefaultColumnFilters = () => {
  return useMemo<ColumnFilter[]>(() => {
    const dayNumber = DateTime.now().day;
    const filter: ColumnFilter = {
      id: 'date',
      value: {
        value: {
          startDate:
            dayNumber > 10
              ? RelativeDateFilter.currentMonth
              : RelativeDateFilter.lastMonth,
        },
        filterType: FilterType.Date,
      },
    };

    return [filter];
  }, []);
};
